module.exports = __webpack_public_path__ + "media/music/bells_1-d6c5dce5.mp3";